module.exports = __webpack_public_path__ + "static/media/desktop10.bbe96a83.png";